import { useMemo } from 'react';
import { useDocuments } from 'store/documents';
import { documentsToDocumentsOnInspectionView } from 'presentation/document/documentsToDocumentsOnInspectionView';
import { InspectionModel } from 'shared/domain/inspection/inspectionModel';

interface UseInspectionDocumentsResult {
  documentsLoading: boolean;
  documentsCount: number;
  inspectionDocuments: ReturnType<
    typeof documentsToDocumentsOnInspectionView
  >;
}

export function useInspectionDocuments(
  inspectionModel: InspectionModel | undefined
): UseInspectionDocumentsResult {
  const documentQuery = useMemo(() => {
    if (!inspectionModel) {
      return undefined;
    }

    return {
      inspectionId: inspectionModel._id,
      templateId: inspectionModel.template,
    };
  }, [inspectionModel]);

  const { documents, loading: documentsLoading } = useDocuments(documentQuery);

  const inspectionDocuments = useMemo(() => {
    return documentsToDocumentsOnInspectionView(documents);
  }, [documents]);

  return {
    documentsLoading,
    documentsCount: documents.length,
    inspectionDocuments,
  };
}
